import React from "react";
import { useParams } from "react-router";
import { gql } from "@apollo/client";
import { useQuery, useSubscription } from "@apollo/client";

import { Container, Grid } from "@mui/material";

import Layout from "components/common/Layout";

import OrderToolbar from "components/order/OrderToolbar";
import OrderSidebar from "components/order/OrderSidebar";
import OrderTimeline from "components/order/OrderTimeline";
import OrderActions from "components/order/OrderActions";

const QUERY = gql`
  query ($orderId: ID!) {
    order(id: $orderId) {
      id
      deleted

      ...OrderToolbar_order
      ...OrderSidebar_order
      ...OrderActions_order
    }
  }

  ${OrderToolbar.fragments.order}
  ${OrderSidebar.fragments.order}
  ${OrderActions.fragments.order}
`;

const SUBSCRIPTION = gql`
  subscription ($orderId: ID!) {
    order(id: $orderId) {
      id
      deleted

      ...OrderToolbar_order
      ...OrderSidebar_order
      ...OrderActions_order
    }
  }

  ${OrderToolbar.fragments.order}
  ${OrderSidebar.fragments.order}
  ${OrderActions.fragments.order}
`;

export default function OrderPage() {
  const { orderId } = useParams();

  const { data, loading } = useQuery(QUERY, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
    variables: { orderId },
  });

  useSubscription(SUBSCRIPTION, { variables: { orderId } });

  if (data?.order?.deleted) {
    return <Layout.Error>Cette commande a été supprimée</Layout.Error>;
  }

  return (
    <>
      {loading && <Layout.Loading />}
      {!loading && !data?.order && <Layout.NotFound />}

      <Container fixed sx={{ p: 2 }}>
        <Layout.Toolbar fixed>
          {data?.order && <OrderToolbar order={data.order} />}
        </Layout.Toolbar>

        <Grid container>
          <Grid item xs={12} md={4}>
            {data?.order && <OrderSidebar order={data.order} />}
          </Grid>

          <Grid item xs={12} md={8}>
            {data?.order && <OrderActions order={data.order} />}
            <OrderTimeline orderId={orderId} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
